<script setup lang="ts">
// Vue & Plugins
import { computed, inject, Ref } from 'vue'
import { useI18n } from 'vue-i18n'

// Components

// Composables
import { useShiftAssignmentDialog } from '../composables/useShiftAssignmentDialog'

// Models
import type { Site } from '../../sites/models/site'
import { currentSiteKey } from '../../common/injection'
import ShiftAssignmentDialogContent from './ShiftAssignmentDialogContent.vue'

const site = inject(currentSiteKey) as Ref<Site>

const { t } = useI18n({ inheritLocale: true })

const {
    isShown,
    hide,
} = useShiftAssignmentDialog()

const content = computed(() => {
    return {
        header: t('shifts.assignments.create.title'),
    }
})
</script>

<template>
  <Dialog
    :visible="isShown"
    :header="content.header"
    dismissable-mask
    close-on-escape
    modal
    class="w-1/2 max-w-2xl"
    @update:visible="hide"
  >
    <ShiftAssignmentDialogContent
      :site-id="site.id"
    />
  </Dialog>
</template>